import React from 'react';
export function App() {
  return <main className="relative w-full min-h-screen overflow-hidden font-body" data-id="element-0">
      {/* Background image — mobile (portrait) */}
      <img src="https://cdn.magicpatterns.com/uploads/jvqVaZG3Qnoz4vrkjUu8BJ/WhatsApp_Image_2026-06-13_at_20.40.21.jpg" alt="Hiker overlooking a vast green valley and distant hills under a bright blue sky" className="absolute inset-0 h-full w-full object-cover sm:hidden" data-id="element-1" />

      {/* Background image — desktop (wide) */}
      <img src="https://cdn.magicpatterns.com/uploads/6o7iZ9Vctu6rWHefKREYH8/ChatGPT_Image_Jun_13,_2026,_08_43_18_PM.png" alt="Hiker overlooking a vast green valley and distant hills under a bright blue sky" className="absolute inset-0 hidden h-full w-full object-cover sm:block" data-id="element-2" />

      {/* Dark overlay for legibility */}
      <div className="absolute inset-0 bg-black/40" data-id="element-3" />

      {/* Content */}
      <div className="relative z-10 flex min-h-screen w-full flex-col items-center justify-center px-6 text-center" data-id="element-4">
        <h1 className="font-display text-5xl font-bold tracking-tight text-white drop-shadow-lg sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-5">
          Yala Hike
        </h1>
        <p className="mt-6 text-lg font-medium uppercase tracking-[0.3em] text-white/80 sm:text-xl" data-id="element-6">
          Coming soon
        </p>
      </div>
    </main>;
}